import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ActiveLog from './activityLog';
import { fetchRunInstanceHistory } from '../../../../../redux/actions/trm/trmDashboard';
import {
  fetchTypologiesActions,
  fetchAMLSAlertLevel
} from '../../../../../redux/actions/common';

function mapStateToProps(state) {
  const { runInstanceHistoryList = {} } = state.trmDashboard;
  const { data, isLoading = true } = runInstanceHistoryList;
  return {
    runInstanceHistoryList: data,
    isLoading,
    trmActions: state.amlsCommon.commonTypologyAction,
    authentication: state.authentication,
    // FIN-12133: alert_level_details configs to colour-code the Action by severity.
    alertLevels: state.amlsCommon.alertLevelConfigs?.data || []
  };
}

function mapDispatchToProps(dispatch) {
  return {
    apiActions: bindActionCreators(
      {
        fetchRunInstanceHistory,
        fetchTypologiesActions,
        fetchAMLSAlertLevel
      },
      dispatch
    )
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ActiveLog);
